
import util from '../../util/Util';
import { LoadCategories } from '../../util/Enum';
import Generalhaulage from '~/components/svgs/quotes/Generalhaulage.vue';
import moment from 'moment';
import { CARRIER} from '../../util/constants';
import ProfilePop from '../ProfilePop.vue';

export default {
  components: {
    Generalhaulage,
    ProfilePop
  },
  props: {
    truck: {
      type: Object,
      default: () => {},
    },
    record: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      LoadCategories,
      util,
      popoverShow:false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user.currentUser;
    },
  },
  methods: {
    profPop(){
      this.popoverShow =!this.popoverShow;
    },
    //TBD. Calls and emails for trucks are not tracking yet
    async recordTruckEmailAndCallStats(type) {
      const payload = {
        truckId: this.truck.id,
        truckName: this.truck.title,
        carrierEmail: this.truck.contactInformation.emailAddress,
        carrierPhone: this.truck.contactInformation.mobilePhone,
        truckIdentifier: this.truck.truckIdentifier,
        userIdentifier: this.currentUser.userIdentifier,
        carrierIdentifier: this.truck.userIdentifier,
        userId: this.currentUser.id,
        statisticType: type,
      };
      await this.$store.dispatch('siteStatistics/recordTruckCallsAndEmails', payload);
    },
    getAddress(data) {
      if (data) {
        return (
          (data.suburb && data.suburb) +
          (data.state && ', ' + data.state) +
          (data.postCode && ', ' + data.postCode)
        ).toUpperCase();
      } else {
        return '-';
      }
    },
    getYear(date) {
      return moment(date).format('MMMM YYYY');
    },
    navigateEditListing() {
       if(this.currentUser && this.currentUser.role == CARRIER && (!this.currentUser.emailConfirmed)|| 
        ((!this.currentUser.subscriptionPlan 
        || !(this.currentUser.subscriptionPlan.isActive))))
      {
      this.$emit('isIncompleteUser');
      } else {
        localStorage.setItem('selectedTruck', JSON.stringify(this.truck));
        this.$router.push({
          path: `/find-transport-carrier/edit-truck?id=${encodeURIComponent(this.truck.id)}`,
        });
      }
    },
    formatCategory() {
      if (this.truck.categories && this.truck.categories.length !== 0) {
        return this.truck.categories.join(', ');
      } else return null;
    },
    formatTruckTypes() {
      if (this.truck.truckTypes && this.truck.truckTypes.length !== 0) {
        return this.truck.truckTypes.join(', ');
      }
    },
  },
};
